/* eslint-disable react/prop-types */
import { base, bsc, mainnet, polygon } from "@reown/appkit/networks";
import {
  useAppKit,
  useAppKitAccount,
  useAppKitNetwork,
} from "@reown/appkit/react";
function ConnectWallet({ className = "" }) {
  const { open } = useAppKit();
  const { isConnected, address } = useAppKitAccount();

  return (
    <button
      type="button"
      className={`px-5 py-2.5 text-white rounded-md text-base font-semibold bg-[linear-gradient(90deg,#FF6EB3_0%,#AA81FF_47.12%,#6BC9FF_100%)] transition duration-300 hover:opacity-90 focus:outline-none ${className}`}
      onClick={() => open(isConnected ? "account" : "connect")}
    >
      {isConnected
        ? `${address?.slice(0, 4)}...${address?.slice(-4)}`
        : "Connect"}
    </button>
  );
}

export default ConnectWallet;
